import React from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {generateFrontCreatorEmailCURLRequest} from '../../../utils/generateFrontCreatorEmailCURLRequest'
import {getPublicUrlForRepo} from '../../../utils/getPublicUrlForRepo'

function formatAwardAmount(amount){
	return `$${(amount /100).toFixed(2)}`
}


class PackReviewDetailPanelEmailPreview extends React.Component{ 


	constructor() {
		super()	


		this.state = { 
		curl:"",
		copied:false
	    }
  	}


  	componentDidUpdate(prevProps) {
  		if(prevProps !==this.props){
  			let emailHTML
			const div=document.getElementById('emailContent')
			if(div){
				emailHTML=div.innerHTML
			}

			const {creator,formattedAwardAmount}=this.props




			const curl=generateFrontCreatorEmailCURLRequest(creator,formattedAwardAmount,emailHTML)
			this.setState({curl:curl,copied:false})

  		}
	
  	}


	render(){
			
		const {creator,formattedAwardAmount,hasQualityAward,hasUsageAward,creatorAwards,giveProForFree} = this.props
		let awardType=''
		if(hasQualityAward && hasUsageAward){
			awardType='both'
		}else if(hasQualityAward){
			awardType='quality'
		}else if(hasUsageAward){
			awardType='usage'
		}

		let hasOneAward = false
		if(creatorAwards && creatorAwards.length === 1){
			hasOneAward = true
		}

		let singleAwardName
		let singleAwardURL

		if(hasOneAward){
			singleAwardName=creatorAwards[0].repo.name
			singleAwardURL=getPublicUrlForRepo(creatorAwards[0].repo)	
			
		}

		const hasOneAwardAndQuality = (awardType==='quality' && hasOneAward)
		const hasOneAwardAndUsage = (awardType==='usage' && hasOneAward)

		let isComplexAwards = true

		if(hasOneAwardAndQuality || hasOneAwardAndUsage){
			isComplexAwards = false
		}

		return( 
			<div className='creatorsList-detailPanel-actionArea-emailTemplater-preview' id="12">
				<div className='creatorsList-detailPanel-actionArea-emailTemplater-preview-title'>
					Email Preview
				</div>				
				<div className='creatorsList-detailPanel-actionArea-emailTemplater-preview-section creatorsList-detailPanel-actionArea-emailTemplater-preview-section--subject'>					
					<div className='creatorsList-detailPanel-actionArea-emailTemplater-preview-section-contents'>						
						Plickers Creator Fund: Congratulations - you’ve been awarded {formattedAwardAmount}!
					</div>					
				</div>
				<div className='creatorsList-detailPanel-actionArea-emailTemplater-preview-section creatorsList-detailPanel-actionArea-emailTemplater-preview-section--body'>					
					<div className='creatorsList-detailPanel-actionArea-emailTemplater-preview-section-contents' id={"emailContent"}>							
							<p>Hi {creator.firstName},</p>
														

							{hasOneAwardAndQuality &&
								<p>
									We are delighted to let you know that your pack <a href={`https://${singleAwardURL}`} target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>{singleAwardName}</a> has <b>earned an exceptional-content award of {formattedAwardAmount}</b> from the February Plickers Creator Fund - congratulations!								
								</p>
							}

							{hasOneAwardAndUsage &&
								<p>
									We are delighted to let you know that your pack <a href={`https://${singleAwardURL}`} target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>{singleAwardName}</a> has earned a classroom-usage award of {formattedAwardAmount} from the February Plickers Creator Fund - congratulations!								
								</p>
							}

							{isComplexAwards &&
								<p>
									{creatorAwards && creatorAwards.map((award)=>{
									return(
										<p>
											<a key={award.id} href={`https://${getPublicUrlForRepo(award.repo)}`} target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>{award.repo.name}</a> / Amount: {formatAwardAmount(award.amount)} / {award.reason}											
										</p>
										)
									})}
								</p>
							}					

							<p>We would love to send this over to you as soon as possible, so if you haven’t done so already, please add your PayPal email to your Plickers account.</p>

							<p>To do this, head over to your <a href='https://www.plickers.com/account' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>Plickers account page</a> and click on ‘Add PayPal Email for Creator Fund Payouts’, located a little way down the page (under the section called ‘Creator Account’).</p>

							{/* Rising Phoenix, for content */}
							{hasOneAwardAndQuality &&
								<p>
									In addition, we are currently looking at creating a collection of the best available packs for early release, and we would be thrilled if you submitted yours for consideration. <b>If your pack is approved, you would be in line to receive an additional $100 award from the Creator Fund!</b> (Each creator can earn up to a maximum of $1,000 from the Creator Fund for early release packs.)
								</p>
							}
							{hasOneAwardAndQuality &&
								<p>					
									To enter <a href={singleAwardURL} target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>{singleAwardName}</a>, please go to your pack page (<a href={singleAwardURL} target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>{singleAwardURL}</a>) and click the ‘Submit for Early Release’ button. We’ll then be back in touch with further details, which may include a request to make some tweaks and changes before approval can be given.
								</p>
							}							


							{/* Pro Offer – All the same */}
							{!hasOneAwardAndUsage && giveProForFree &&
								<p>If you do decide to submit your pack for early release, <b>we’d be very happy to offer you a free Plickers Pro subscription</b>. We hope that it will come in handy for adding to your already wonderful content, and to make it as useful and engaging as possible for teachers around the world.</p>
							}
							
							{!hasOneAwardAndUsage && giveProForFree &&
								<p>To activate Plickers Pro, please enter the license key F4FC9805C4 into your account page, or click on this link: <a href='https://www.plickers.com/claim?key=F4FC9805C4 ' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'underline'}}>https://www.plickers.com/claim?key=F4FC9805C4</a></p>
							}

							{/* End Section – All the same */}
							<p>Please do let us know if you have any questions at all, and we hope you are safe and well during this difficult time.</p>
							<p>All the best,</p>
							<p>Joe</p>																			

					</div>	


						<CopyToClipboard text={this.state.curl} onCopy={()=>{this.setState({copied:true})}}>
							<button 
								className={'packReview-detailPanel-actionArea-btn creatorsList-detailPanel-actionArea-btn--frontButton ' + (this.state.copied ? 'packReview-detailPanel-actionArea-btn--disabled':'')}
								disabled={this.state.copied}
							>								
								{this.state.copied &&
									<React.Fragment>Copied to Clipboard</React.Fragment>
								}
								{!this.state.copied &&
									<React.Fragment>
										<svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Lab_flask" x="0px" y="0px" viewBox="0 0 20 20" enableBackground="new 0 0 20 20"><path fillRule="evenodd" clipRule="evenodd" d="M16.432,15C14.387,9.893,12,8.547,12,6V3h0.5C12.776,3,13,2.776,13,2.5v-1  C13,1.224,12.776,1,12.5,1h-5C7.224,1,7,1.224,7,1.5v1C7,2.776,7.224,3,7.5,3H8v3c0,2.547-2.387,3.893-4.432,9  C2.917,16.625,1.245,19,10,19S17.083,16.625,16.432,15z M14.815,16.751C14.113,16.961,12.716,17.2,10,17.2s-4.113-0.239-4.815-0.449  c-0.249-0.074-0.346-0.363-0.258-0.628c0.22-0.67,0.635-1.828,1.411-3.121c1.896-3.159,3.863,0.497,5.5,0.497  c1.637,0,1.188-1.561,1.824-0.497c0.774,1.294,1.191,2.451,1.411,3.121C15.161,16.388,15.064,16.676,14.815,16.751z"></path></svg>
										<b>Copy cURL</b>&nbsp;to Clipboard
									</React.Fragment>
								}
							</button>							
						</CopyToClipboard>									
													
				</div>

			</div>				
		)
	}
}


export default PackReviewDetailPanelEmailPreview
